import * as React from 'preact';

const OptionButtonGroupContext = React.createContext(undefined);

if (process.env.NODE_ENV !== 'production') {
  OptionButtonGroupContext.displayName = 'OptionButtonGroupContext';
}

export default OptionButtonGroupContext;
